<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'LEGAL.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'TERMS.TITLE' | translate }}</h1>
      <nav class="ph-legal-nav" aria-label="Legal">
        <a routerLink="/legal/privacy" routerLinkActive="ph-legal-nav__link--active">{{ 'PRIVACY.TITLE' | translate }}</a>
        <a routerLink="/legal/privacy-policy" routerLinkActive="ph-legal-nav__link--active">{{ 'PRIVACY_POLICY.TITLE' | translate }}</a>
        <a routerLink="/legal/cookie-preferences" routerLinkActive="ph-legal-nav__link--active">{{ 'COOKIES.TITLE' | translate }}</a>
        <a routerLink="/legal/terms" routerLinkActive="ph-legal-nav__link--active">{{ 'TERMS.TITLE' | translate }}</a>
      </nav>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <article class="ph-legal">
        <p class="ph-legal__updated">
          {{ 'TERMS.LAST_UPDATED' | translate }}: {{ '2024-03-20' | date:'longDate' }}
        </p>

            <section>
                <h2>{{ 'TERMS.GENERAL.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.GENERAL.DESCRIPTION' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.ABOUT_US.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.ABOUT_US.DESCRIPTION' | translate: translationParams }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.SCOPE.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.SCOPE.PARAGRAPH_DES_1' | translate }}</p>
                <p>{{ 'TERMS.SCOPE.PARAGRAPH_DES_2' | translate }}</p>
                <p>{{ 'TERMS.SCOPE.PARAGRAPH_DES_3' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.WHAT_WE_DO.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_1.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_1.SUBP_2' | translate }}</p>
                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_1.SUBP_3' | translate }}</p>

                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_2.SUBP_1' | translate }}</p>

                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_3.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_3.SUBP_2' | translate }}</p>

                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_4.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_4.SUBP_2' | translate }}</p>

                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_5.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.WHAT_WE_DO.PARAGRAPH_5.SUBP_2' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.REGISTRATION.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.REGISTRATION.PARAGRAPH_1.SUBP_1' | translate }}</p>

                <p>{{ 'TERMS.REGISTRATION.PARAGRAPH_2.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.REGISTRATION.PARAGRAPH_2.SUBP_2' | translate }}</p>

                <p>{{ 'TERMS.REGISTRATION.PARAGRAPH_3.SUBP_1' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.APPLICATION.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_1.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_1.SUBP_2' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_1.SUBP_3' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_1.SUBP_4' | translate }}</p>

                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_2' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_LIST_1.TITLE' | translate }}</p>
                <ul>
                    <li>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_LIST_1.LIST.0' | translate }}</li>
                    <li>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_LIST_1.LIST.1' | translate }}</li>
                </ul>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_3' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_2.SUBP_4' | translate }}</p>

                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_3.SUBP_1' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_3.SUBP_2' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_3.SUBP_3' | translate }}</p>
                <p>{{ 'TERMS.APPLICATION.PARAGRAPH_3.SUBP_4' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.CONTRACT.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.CONTRACT.PARAGRAPH_1' | translate }}</p>
                <p>{{ 'TERMS.CONTRACT.PARAGRAPH_2' | translate }}</p>
                <p>{{ 'TERMS.CONTRACT.PARAGRAPH_3' | translate }}</p>

                <p>{{ 'TERMS.CONTRACT.PARAGRAPH_4.TITLE' | translate }}</p>
                <ul>
                    <li>{{ 'TERMS.CONTRACT.PARAGRAPH_4.CONTENT.0' | translate }}</li>
                    <li>{{ 'TERMS.CONTRACT.PARAGRAPH_4.CONTENT.1' | translate }}</li>
                    <li>{{ 'TERMS.CONTRACT.PARAGRAPH_4.CONTENT.2' | translate }}</li>
                    <li>{{ 'TERMS.CONTRACT.PARAGRAPH_4.CONTENT.3' | translate }}</li>
                    <li>{{ 'TERMS.CONTRACT.PARAGRAPH_4.CONTENT.4' | translate }}</li>
                </ul>
            </section>

            <section>
                <h2>{{ 'TERMS.CUSTOMER_SUPPORT.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.CUSTOMER_SUPPORT.PARAGRAPH_1' | translate }}</p>
                <p>{{ 'TERMS.CUSTOMER_SUPPORT.PARAGRAPH_2' | translate }}</p>
                <p>{{ 'TERMS.CUSTOMER_SUPPORT.PARAGRAPH_3' | translate }}</p>
                <p>{{ 'TERMS.CUSTOMER_SUPPORT.PARAGRAPH_4' | translate }}</p>
            </section>

            <section>
                <h2>{{ 'TERMS.DATA_PROTECTION.TITLE' | translate }}</h2>
                <p>{{ 'TERMS.DATA_PROTECTION.PARAGRAPH_1' | translate }}</p>
                <p>{{ 'TERMS.DATA_PROTECTION.PARAGRAPH_2' | translate }}</p>
                <p>{{ 'TERMS.DATA_PROTECTION.PARAGRAPH_3' | translate }}</p>
                <p>{{ 'TERMS.DATA_PROTECTION.PARAGRAPH_4' | translate }}</p>
            </section>

        <section class="ph-legal__contact">
          <h2>{{ 'TERMS.CONTACT.TITLE' | translate }}</h2>
          <p>{{ 'TERMS.CONTACT.DESCRIPTION' | translate }}</p>
          <p><strong>{{ 'CONTACT.DATA.EMAIL_CONTACT.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.EMAIL_CONTACT.VALUE' | translate: translationParams }}</p>
          <p><strong>{{ 'CONTACT.DATA.PHONE.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.PHONE.VALUE' | translate: translationParams }}</p>
        </section>
      </article>
    </div>
  </section>
</div>
